module.exports = __webpack_public_path__ + "img/paint-10.98f0fecb.png";